<template>
  <div class="patrocinadores" id = "patrocinadores">
    <b-container fluid>
      <h1 class="titulo">PATROCINADORES</h1>
      <b-img :src="svgTitulo" class="svgTitulo"></b-img>
    </b-container>
 
    <b-container class="bv-example-row bv-example-row-flex-cols">
      <b-row align-v="center">
        <b-col md = "4">
          <b-img  class = "imagemPatrocinador" v-bind:src="logoEquals"></b-img>
        </b-col>
        <b-col md = "4">
          <b-img  class = "imagemPatrocinador logoAccenture" v-bind:src="logoAccenture"></b-img>
        </b-col>
        <b-col md = "4">
          <b-img class = "imagemPatrocinador" v-bind:src="logoHotmart"></b-img>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="bv-example-row bv-example-row-flex-cols">
      <b-row align-v="center space">
        <b-col md = "3" sm="12" cols="12">
          <b-img  class = "imagemPatrocinador" v-bind:src="logoGerencianet"></b-img>
        </b-col>
        <b-col md = "3" sm="12" cols="12">
          <b-img  class = "imagemPatrocinador" v-bind:src="logoMatera"></b-img>
        </b-col>
        <b-col md = "3" sm="12" cols="12">
          <b-img  class = "imagemPatrocinador" v-bind:src="logoSquadra"></b-img>
        </b-col>
        <b-col md = "3" sm="12" cols="12">
          <b-img class = "imagemPatrocinador" v-bind:src="logoSydle"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
 
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
 
html, body {
  font-family: 'Roboto Condensed', sans-serif;
}
 
#app {
  font-family: 'Roboto Condensed', sans-serif;
}
 
.patrocinadores {
    background-image: url('~@/assets/Patrocinadores/fundoPatrocinadoresSvg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
 
.imagemPatrocinador {
  margin-bottom: 55px;
  width: 200px;
  height: auto;
}

.logoAccenture{
  height: auto !important;
  width: 110% !important;
}
.logos {
  margin-bottom: 100px;
}
@media only screen and (max-width: 991px) {
  .imagemPatrocinador {
  margin-bottom: 55px;
  width: 160px;
  height: auto;
}

}
@media only screen and (max-width: 768px) {
  .imagemPatrocinador {
    margin-bottom: 55px;
  }
  .logoAccenture{
    height: auto;
    width: 70% !important;
    margin-bottom: 55px;
  }
  .logos {
    margin-bottom: 0px;
  }
}
.svgTitulo {
  width: 220px;
  top: 50%;
  left: 50%;
  margin-bottom: 75px;
  margin-top: -7px;
}
 
.titulo {
  padding-top: 100px;
  font-size: 1.6em;
  text-align: center;
  font-weight: 300;
  color: black;
}
 
.spaceTitulo {
    padding-bottom: 40px;
}
 
.space {
    padding-bottom: 50px;
}
 
.corPatrocinio {
    font-weight: lighter;
    font-size: 1.9em;
    color: #414141;
    padding-bottom: 20px;
}
 
.imagemDiamante {
    height: 100px;
}
 
</style>
 
<script>
export default {
  name: "Patrocinadores",
  data() {
    return {
      logoAccenture: require("../assets/Patrocinadores/accenture.png"),
      logoGerencianet: require("../assets/Patrocinadores/gerencianet.png"),
      logoEquals: require("../assets/Patrocinadores/Equals_logo.png"),
      logoHotmart: require("../assets/Patrocinadores/Hotmart-logo-02.png"),
      logoMatera: require("../assets/Patrocinadores/matera.png"),
      logoSquadra: require("../assets/Patrocinadores/squadra.png"),
      logoSydle: require("../assets/Patrocinadores/sydle.png"),
      svgTitulo: require("../assets/Patrocinadores/linhaTitulo.svg"),
    };
  }
};
</script>
